import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.idp-authenticators.manage', {
        url: '/manage/:idpAuthenticatorId',
        redirectTo: 'company.idp-authenticators.manage.config',
        component: 'companyIdpAuthenticatorsManage',
        resolve: {
            $breadcrumbs,
            idpAuthenticator
        },

    });
}

/** @ngInject */
function idpAuthenticator(idpAuthenticators, $stateParams) {
    return idpAuthenticators.find(idp => idp.id === $stateParams.idpAuthenticatorId);
}

/** @ngInject */
function $breadcrumbs(idpAuthenticator) {
    if(idpAuthenticator == null) {
        return;
    }
    const title = {
        // getter to allow dynamic updates
        get title() {
            return idpAuthenticator.name
        }
    };

    return [{stateName: 'company.idp-authenticators.manage'}, title];

}




// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/idp-authenticator-manage.state.js